module.exports = __webpack_public_path__ + "img/AD.2e24e21d.png";